<script lang="ts">
  export let name: string = '';
  export let logo: string = '';
  export let logoBorderColor: string = 'transparent';
  export let logoBorderThickness: string = '0px';
  export let logoBorderRadius: string = '0px';
  export let logoWidth: string = '120px';
  export let logoHeight: string = '120px';

  function getInitial(name: string): string {
    return name?.charAt(0).toUpperCase() || "";
  }
</script>

<div 
  class="logo-wrapper"
  style="--logo-border-color: {logoBorderColor}; --logo-border-thickness: {logoBorderThickness}; --logo-border-radius: {logoBorderRadius}; --logo-width: {logoWidth}; --logo-height: {logoHeight};"
>
  {#if logo}
    <img src={logo} alt="{name} logo" class="store-logo" />
  {:else}
    <div class="logo-fallback">
      {getInitial(name)}
    </div>
  {/if}
</div>

<style lang="scss">
  .logo-wrapper {
    flex-shrink: 0;
    width: var(--logo-width);
    height: var(--logo-height);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: var(--logo-border-radius);
    border: var(--logo-border-thickness) solid var(--logo-border-color);
  }

  .store-logo {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    aspect-ratio: 1 / 1;
  }

  .logo-fallback {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    font-size: 3rem;
    font-weight: 600;
  }
</style> 